<template>
  <div v-bind="$attrs">
    <label v-if="label" class="text-gray-700 font-semibold text-base ml-2 mb-1 inline-block">{{ label }}</label>
    <slot name="antDesignSlot" :antDesignProps="antDesignProps">
      <form-antd-toggle
        v-bind="antDesignProps || {}"
        :disabled="disabled"
        :checkedChildren="onLabel"
        :unCheckedChildren="offLabel"
        :modelValue="modelValue"
        @update:value="
          (newValue) => {
            updateModelValue(newValue)
            $emit('update:modelValue', newValue)
          }
        "
      />
    </slot>
  </div>
</template>

<script>
import FormAntdToggle from './AntDesign/FormAntdToggle.vue'

export default {
  components: {
    FormAntdToggle
  },
  props: {
    /**
     * Default toggle value
     * @model
     */
    modelValue: {
      type: Boolean,
      default: false
    },
    /**
     * Default label when toggle is active / checked.
     */
    onLabel: {
      type: String,
      default: 'On'
    },
    /**
     * Default label when toggle is not active / unchecked.
     */
    offLabel: {
      type: String,
      default: 'Off'
    },
    /**
     * Width of the toggle in pixels.
     */
    width: {
      type: Number,
      default: 60
    },
    /**
     * Label that will be visible above the toggle button.
     */
    label: {
      type: String,
      default: ''
    },
    /**
     * Disable the button
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Ant Design Props.
     */
    antDesignProps: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  emits: ['update:modelValue'],
  methods: {
    updateModelValue(value) {
      this.$emit('update:modelValue', value)
    }
  }
}
</script>

<style></style>
